<template>
    <div class="full">
        <div class="systemTypeContainer">
            <h1>{{ $t("displayerSystemType.displayerTitle") }}</h1>
            <h2>{{ $t("displayerSystemType.selectSystemType") }}</h2>
            <div class="systemTypeBlocContainer">
                <router-link to="/param_meuble"> <SystemTypeItem :systemTypeId="1"></SystemTypeItem> </router-link>
                <router-link to="/templates/new?type=2"> <SystemTypeItem :systemTypeId="2"></SystemTypeItem> </router-link>
                <router-link to="/templates/new?type=3"> <SystemTypeItem :systemTypeId="3"></SystemTypeItem> </router-link>
                <router-link to="/templates/new?type=4"> <SystemTypeItem :systemTypeId="4"></SystemTypeItem> </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import SystemTypeItem from "./components/system-type-item";

export default {
    components: {
        SystemTypeItem
    }
};
</script>

<style scoped lang="scss">
@import "../../../../assets/css/themes";

.systemTypeContainer {
    @extend %primary-text;
    h1 {
        text-transform: uppercase;
        font-size: 40px;
        font-family: "Oswald";
        font-weight: normal;
    }
    h2 {
        text-transform: uppercase;
        font-size: 20px;
        font-family: "Oswald";
        font-weight: normal;
    }
    .systemTypeBlocContainer {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// carcass.vue?05be0b08